import { useState } from 'react'

import { SelectOption } from 'components/Select'
import { CSManagerDTO } from 'features/workspace/api/types/workspaceDTO'
import { csManagerFromDTO } from 'features/workspace/mappers/csManager'
import { CSManager } from 'features/workspace/types/csManager'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { GET_CS_MANAGERS_FOR_SELECT } from './api/query'
import { Data } from './api/types'
import { UseGetCSManagersForSelect } from './types'

export const useGetCSManagersForSelect = (): UseGetCSManagersForSelect => {
  const [csManagers, setCSManagers] = useState<SelectOption<CSManager>[]>([])

  useQuery<never, Data>({
    onCompleted: async (data: Data) => {
      const {
        customerSuccessUsers: { nodes: csManagers },
      } = data

      if (csManagers && csManagers.length > 0) {
        setCSManagers(
          csManagers.map((csm: CSManagerDTO): SelectOption<CSManager> => {
            const { firstName, id, lastName } = csManagerFromDTO(csm)

            return {
              label: `${firstName} ${lastName}`,
              value: id,
            }
          }),
        )
      }
    },
    query: GET_CS_MANAGERS_FOR_SELECT,
  })

  return { csManagers }
}
